import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { responseTypes, serviceTypes } from "utils/Types";
import { axiosGet, axiosPost } from "../../../utils/APIHelper";

export let userList: any = [];

export function setUserList(newList: any[]) {
  userList = newList;
}

const initialState: any = {
  globalUserDetail: [],
  globalUserListLoading: true,
  totalGlobalUser: 0,
  category: "Property",
  globalPlanList: [],
  globalInncodeList: []
};

export const fetchGlobalUser = createAsyncThunk("globalSearch/fetchUser", async (data: any, thunkApi) => {
  const API_URL = `associates/?page=${data.page}&size=${data.size}&searchText=${data.value}&innCodes=${
    data?.innCode || ""
  }&includecorpusers=${data?.includecorpusers ?? false}`;
  const response: any = await axiosGet(API_URL, serviceTypes.user);
  if (
    (response?.response?.status >= responseTypes.internal_error &&
      response?.response?.status < responseTypes.other_error) ||
    response?.response?.status === responseTypes.not_found
  ) {
    return thunkApi.rejectWithValue(response.response);
  }
  return response.data;
});

export const fetchGlobalPlansAsync = createAsyncThunk("globalSearch/fetchPlan", async (data: any, thunkApi) => {
  const API_URL = `plans?externalHltId=${data?.externalHltId || ""}`;
  const response: any = await axiosPost(API_URL, serviceTypes.library, data);
  if (
    response?.response?.status >= responseTypes.internal_error &&
    response?.response?.status < responseTypes.other_error
  ) {
    return thunkApi.rejectWithValue(response.response);
  }

  return response.data;
});

export const fetchGlobalInncodes = createAsyncThunk(`globalSearch/Inncode`, async (data: string, thunkApi) => {
  const API_URL = `innCodes?searchText=${data}`;
  const response = await axiosGet(API_URL, serviceTypes.library);
  return response.data;
});

export const GlobalSearchSlice = createSlice({
  name: "Global Search",
  initialState,
  reducers: {
    clearSearch: (state) => {
      state.globalUserDetail = [];
    },
    clearPlanSearch: (state) => {
      state.globalPlanList = [];
    },
    clearInnCodeSearch: (state) => {
      state.globalInncodeList = [];
    },
    setCategory: (state, action) => {
      state.category = action.payload;
    }
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchGlobalUser.pending, (state, action) => {
        state.globalUserListLoading = true;
      })
      .addCase(fetchGlobalUser.fulfilled, (state, action) => {
        state.globalUserListLoading = false;
        state.totalGlobalUser = action.payload?.meta?.page?.total;

        const newUsers = action.payload?.users;
        userList = [...userList, ...newUsers];
        state.globalUserDetail = userList;
      })
      .addCase(fetchGlobalUser.rejected, (state, action) => {
        state.globalUserListLoading = false;
        state.globalUserDetail = [];
      })
      .addCase(fetchGlobalPlansAsync.fulfilled, (state, action: any) => {
        state.globalPlanList = action?.payload?.plans;
      })
      .addCase(fetchGlobalInncodes.fulfilled, (state, action: any) => {
        state.globalInncodeList = action?.payload?.properties;
      });
  }
});

export const { clearSearch, setCategory, clearPlanSearch, clearInnCodeSearch } = GlobalSearchSlice.actions;

export default GlobalSearchSlice.reducer;
